import * as S from "./styles";
import * as RootS from "../styles";
import { Group } from "@assets/icons";
import { ArrowRightCircle, CheckCircle } from "react-feather";
import { format } from "@utils/utils";
import { useAffiliateData } from "@hooks/affiliates/affiliate/useAffiliateData";
import { useRouter } from "next/router";
import { Button } from "@kirvanobr/button";

export default function ProductCard() {
  const { data, acceptAffiliation } = useAffiliateData();
  const router = useRouter();
  const product = data?.product;
  const affiliatesEnabled = data?.affiliatesEnabled;
  const acceptAndRedirect = () => {
    acceptAffiliation();
    router.push("/");
  };

  if (!product) return <></>;
  return (
    <RootS.ContentCard small alignItems="start">
      <S.ProductContent>
        <S.Image variant="medium" photoURL={product.photo} format={product.format} />
        <S.ProductDetails justifyCenter={!affiliatesEnabled}>
          <RootS.SubTitle>{product.name}</RootS.SubTitle>
          {affiliatesEnabled && (
            <>
              {product.salesCount != 0 && (
                <S.UpsellContent>
                  <Group width={24} height={24} />
                  <RootS.Span bold small>
                    {format.localeNumber(product.salesCount)}
                  </RootS.Span>
                  <RootS.Text small>vendas realizadas</RootS.Text>
                </S.UpsellContent>
              )}
              <S.UpsellContent>
                <RootS.Text>
                  Você pode lucrar até
                  <RootS.Span blue bold>
                    {" "}
                    {format.money(product.maxPrice)}{" "}
                  </RootS.Span>
                  por venda*
                </RootS.Text>
              </S.UpsellContent>
            </>
          )}
        </S.ProductDetails>
      </S.ProductContent>
      {affiliatesEnabled ? (
        <Button onClick={acceptAndRedirect} fullWidth startContent={<CheckCircle />}>
          Estou ciente e quero me afiliar
        </Button>
      ) : (
        <Button onClick={() => router.push(product.productPage)} fullWidth endContent={<ArrowRightCircle />}>
          Ir para a página de vendas do produtor
        </Button>
      )}

      {affiliatesEnabled && (
        <RootS.Text xs light displayMiddle>
          Sujeito a aprovação
        </RootS.Text>
      )}
    </RootS.ContentCard>
  );
}
